import { colors, getSpacing } from '@cabonline/ui-shared';
import { Text } from '@cabonline/ui-web';
import styled from '@emotion/styled';
import React from 'react';

const BannerContainer = styled.div`
  background-color: #fff3cd;
  padding: ${getSpacing('s')} ${getSpacing('m')};
  text-align: center;
  border-bottom: 2px solid #ffc107;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

const BannerText = styled(Text)`
  font-weight: 600;
  color: ${colors.black};
  margin: 0;
`;
const Divider = styled.hr`
  border: none;
  height: 1px;
  background: ${colors.black};
  opacity: 0.08;
  margin: ${getSpacing('s')} 0;
  width: 70%;
  justify-self: center;
`;

export const StockholmBanner = (): React.ReactElement => {
  return (
    <BannerContainer>
      <BannerText>
        <span role="img" aria-label="warning">⚠️</span> Production data from Frogne is available in this test environment — please be cautious: changes you make to data here may impact real production records.
      </BannerText>
      <Divider />
      <BannerText>
        <span role="img" aria-label="warning">⚠️</span> We're working with the Stockholm City project. Before deploying to the
        test environment, please notify the DICH team so they can coordinate and
        help.
      </BannerText>
    </BannerContainer>
  );
};
